import { SegmentationIds } from 'constants/segmentation';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UserSegmentationState {
  segments: SegmentationIds[];
  addSegment: (segment: SegmentationIds) => void;
  removeSegment: (segment: SegmentationIds) => void;
}

/**
 * Store for managing user-centric segmentation data.
 * This store persists segments that come from user interactions (filter clicks, CDP navigation)
 * and maintains them across pet profile switches, removing only incompatible segments.
 */
export const useUserSegmentationStore = create<UserSegmentationState>()(
  persist(
    (set) => ({
      segments: [],
      addSegment: (segment) =>
        set((state) => ({
          segments: state.segments.includes(segment)
            ? state.segments
            : [...state.segments, segment].sort((a, b) => a.localeCompare(b)),
        })),

      removeSegment: (segment) =>
        set((state) => ({
          segments: state.segments.filter((s) => s !== segment),
        })),
    }),
    {
      name: 'pd:user-segmentation-store',
    }
  )
);
